import React from 'react';
import {Navigate, Outlet} from 'react-router-dom'

const EmpPrivateComponent=()=>{
    const auth=localStorage.getItem('empuser');
    return auth?<Outlet/>:<Navigate to="/mark-attendance"/>
}

export default EmpPrivateComponent;